export const DEFAULT_LOADING_KEY = Symbol('defaultLoadingKey');

export type LoadingKey = typeof DEFAULT_LOADING_KEY | 'getEmployeeList';
